export const SET_ACL = '@manakin/authorization/SET_ACL';

export function setAcl(acl) {
    return {
        type: SET_ACL,
        payload: { acl },
    };
}
